import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { CircularAvatar } from "../../commons";
import { PeopleOnLeaveListType } from "../../../redux/mySpace/mySpaceTypes";
type AppProps = {
  data: PeopleOnLeaveListType[] | [];
  tableHeader: TableHeadersType[];
};
const PeopleOnLeaveTableData = ({ data, tableHeader }: AppProps) => {
  return (
    <>
      {data?.length > 0 &&
        data?.map((el: PeopleOnLeaveListType) => {
          return (
            <tr className="text-left">
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value === "name") {
                    return (
                      <td className="text-left" style={{ minWidth: "200px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            gap: "14px",
                          }}
                        >
                          <CircularAvatar
                            name={`${el?.first_name + el?.last_name} `}
                            image={el?.profile_pic && el?.profile_pic?.file_url}
                          />
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <span style={{ fontSize: "14px" }}>
                              {el?.first_name + " " + el?.last_name}
                            </span>
                            <span
                              style={{ color: "#6e7491", fontSize: "12px" }}
                            >
                              {el?.job_title ? el?.job_title : ""}
                              {el?.department ? `, ${el?.department}` : ""}
                            </span>
                          </div>
                        </div>
                      </td>
                    );
                  } else if (header?.value === "on_leave") {
                    return (
                      <td>
                        <span>
                          {el?.start_date} to {el?.end_date}
                        </span>
                      </td>
                    );
                  }
                  return null;
                })}
            </tr>
          );
        })}
    </>
  );
};

export default PeopleOnLeaveTableData;
